import React, { useState, useEffect } from "react";
import Popup1 from "./popup1";
import Popup2 from "./popup2";

import { Link } from "react-router-dom";
const SimulatorForm = ({ simulatorQuery, search, catagories }) => {
  const [popupToggle1, setpopupToggle1] = useState(false);
  const [popupToggle2, setpopupToggle2] = useState(false);
  const [Blankform, setBlankform] = useState("");
  const [Studymate, setStudymate] = useState("");

  useEffect(() => {
    console.log(simulatorQuery);
  });

  const popup1 = (data) => {
    setpopupToggle1(!popupToggle1);
    setBlankform(data);
  };
  const popup2 = (data) => {
    setpopupToggle2(!popupToggle2);
    setStudymate(data);
  };

  return (
    <div>
      {simulatorQuery?.aatmsv4_simforms?.map((data, index) => {
        if (data?.simformname.toLowerCase().includes(search.toLowerCase())) {
          return (
            <div className="table-row-container" key={index}>
              {/* <div className="table-row-top " id="simulatorForm__box"> */}
              <div className="simulator-row-top">
                <div className="items">
                  <div className="title">SimForm Name</div>
                  <div className="value">{data?.simformname}</div>
                </div>
                {/* <div className="items">
                        <div className="title">Catagory</div>
                        <div className="value">{catagories}</div>
                      </div> */}
                <div className="items">
                  <div className="title">SimForm Name</div>
                  <div className="sim-center">
                    {/*                   
                    <Link
                      onClick={() => {
                        window.open(data?.blankform);
                      }}
                    >
                      Form
                    </Link> */}
                    <Link
                      onClick={() => {
                        popup1(data?.blankform);
                      }}
                    >
                      {popupToggle1 === true ? (
                        <Popup1
                          setpopupToggle1={setpopupToggle1}
                          simulatorData={Blankform}
                        />
                      ) : null}
                      Form
                    </Link>
                  </div>
                  {/* <div className="value">
                    <a href={data?.blankform} target="_blank">
                      Form
                    </a>
                  </div> */}
                </div>
                <div className="items">
                  <div className="title">SimForm Name</div>
                  <div className="sim-center">
                    <Link
                      onClick={() => {
                        popup2(data?.studymat);
                      }}
                    >
                      {popupToggle2 === true ? (
                        <Popup2
                          setpopupToggle2={setpopupToggle2}
                          simulatorData={Studymate}
                        />
                      ) : null}
                      Study
                    </Link>
                  </div>
                  {/* <div className="value">
                    <a href={data?.studymat} target="_blank">
                      Study
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default SimulatorForm;
